import { render, staticRenderFns } from "./examineYuyue.vue?vue&type=template&id=06f37200&scoped=true&"
import script from "./examineYuyue.vue?vue&type=script&lang=js&"
export * from "./examineYuyue.vue?vue&type=script&lang=js&"
import style0 from "./examineYuyue.vue?vue&type=style&index=0&id=06f37200&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f37200",
  null
  
)

export default component.exports